const API_AUTH_USERNAME = process.env.REACT_APP_API_AUTH_USERNAME;
const API_AUTH_PASSWORD = process.env.REACT_APP_API_AUTH_PASSWORD;
const API_BASE_URL = process.env.REACT_APP_API_URL;
export { API_AUTH_USERNAME, API_AUTH_PASSWORD, API_BASE_URL };

